import { ProgressBar } from 'primereact/progressbar';

export default function InternalProgressBarSpinner(props) {
  return (
    <ProgressBar className='InternalProgressBarSpinner' mode="indeterminate" {...props} />
  );
}